import React, { useContext } from "react";
import { BrowserRouter as Router, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/GlobalStyles';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth, AuthContext } from './contexts/AuthContext';
import Login from "./pages/Login";
import AuthVerify from "./pages/AuthVerify";

// Components
import Dashboard from './pages/Dashboard';
import Canvas from './pages/Canvas';
import MyDecks from './pages/MyDecks';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import StoryGenerator from './pages/StoryGenerator';
import Loading from './components/Loading';
import AppWithRouter from './AppWithRouter';

// Styles
import { GlobalStyles } from './styles/GlobalStyles';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loading />;
  }

  return user ? children : <Navigate to="/login" replace />;
};

// Admin Route Component
const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loading />;
  }

  return user && user.role === 'admin' ? children : <Navigate to="/dashboard" replace />;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <Router>
        <AppWithRouter />
      </Router>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App; 